module.exports = __webpack_public_path__ + "img/zoom_graph.b1abf513.svg";